var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpek(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_480_11313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2497 24H7.74967C7.37967 24 7.06467 23.73 7.00867 23.364L6.00867 16.864C5.97567 16.648 6.03767 16.427 6.18067 16.261C6.32367 16.095 6.53067 16 6.74967 16H17.2497C17.4687 16 17.6767 16.096 17.8187 16.262C17.9607 16.428 18.0237 16.648 17.9907 16.865L16.9907 23.365C16.9347 23.73 16.6197 24 16.2497 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8C14.2091 8 16 6.20914 16 4C16 1.79086 14.2091 0 12 0C9.79086 0 8 1.79086 8 4C8 6.20914 9.79086 8 12 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2183 13C23.0593 10.783 21.8673 8.731 20.0003 7.49C19.9953 6.666 19.3263 6 18.5013 6C17.6733 6 17.0013 6.672 17.0013 7.5C17.0013 8.328 17.6733 9 18.5013 9C18.7753 9 19.0283 8.921 19.2493 8.793C20.6563 9.762 21.5653 11.315 21.7183 13H19.9413C19.5813 10.74 17.6213 9 15.2513 9H8.75125C6.38125 9 4.42125 10.74 4.06125 13H0.751252C0.220252 13 -0.122749 13.538 0.0412515 14.01L2.04125 19.51C2.15125 19.8 2.43125 20 2.75125 20H4.47125L4.03125 17.17C3.91125 16.37 4.14125 15.57 4.66125 14.96C5.10725 14.425 5.89625 14 6.75125 14H17.2513C18.0063 14 18.7683 14.311 19.3413 14.96C19.8613 15.57 20.0913 16.37 19.9713 17.17L19.5313 20H21.2513C21.5713 20 21.8513 19.8 21.9613 19.51L23.9613 14.01C24.1193 13.555 23.8173 13 23.2183 13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_480_11313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpek);
export default __webpack_public_path__ + "static/media/SPEK.27af3760771560e4aa6ba808d36d7021.svg";
export { ForwardRef as ReactComponent };